<template>
  <footer class="footer mt-5">
    <div class="container-fluid">
      <span>© 2019-2020 Euro Media Group</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
<style lang="scss" scoped>
html {
  position: relative;
  min-height: 100%;
}
body {
  margin-bottom: 60px; /* Margin bottom by footer height */
}
.footer {
  position: relative;
  bottom: 0;
  width: auto;
  height: 60px; /* Set the fixed height of the footer here */
  line-height: 60px; /* Vertically center the text there */
  color: #d8d8d8;
}
img.logo{
  height: 30px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue